import { gql } from '@apollo/client';

/**
 * GraphQL query to get custom labels for a community
 */
export const GET_CUSTOM_LABELS = gql`
  query GetCustomLabels($communityId: ID!) {
    customLabels(communityId: $communityId) {
      labels {
        id
        communityId
        name
        description
        labelType
        active
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
      }
    }
  }
`;
